import React from "react";

import FinalReviewForm from "components/FinalReviewForm";

export default class CorporateAccountUserOnboardingCompletePage extends React.Component {
    render() {
        return (
            <div className="bp-page-content bp-page-large verification-page">
                <FinalReviewForm/>
            </div>
        );
    }
}
